import { createSlice } from '@reduxjs/toolkit';

import {
	getTicketShares,
	revokeTicketSharePermission,
	updateTicketSharePermission,
} from './asyncActions';
import { ITicketShareReducer } from './types';

const initialState: ITicketShareReducer = {
	isCreateTicketShareOpen: false,
	currentTicketPermissions: [],
	isCurrentTicketSharesLoading: false,
};

const ticketShareSlice = createSlice({
	name: 'ticketShare',
	initialState,
	reducers: {
		setIsCreateTicketShareOpen: (state, action) => {
			state.isCreateTicketShareOpen = action.payload;
		},
		resetTicketShareStore: () => initialState,
	},
	extraReducers: (builder) => {
		builder.addCase(getTicketShares.pending, (state) => {
			state.isCurrentTicketSharesLoading = true;
		});
		builder.addCase(getTicketShares.rejected, (state) => {
			state.currentTicketPermissions = [];
			state.isCurrentTicketSharesLoading = false;
		});
		builder.addCase(getTicketShares.fulfilled, (state, { payload }) => {
			state.currentTicketPermissions = payload;
			state.isCurrentTicketSharesLoading = false;
		});
		builder.addCase(revokeTicketSharePermission.fulfilled, (state, { payload }) => {
			state.currentTicketPermissions = state.currentTicketPermissions.filter(
				(permission) => !payload.shareIds.includes(permission.id)
			);
		});
		builder.addCase(updateTicketSharePermission.fulfilled, (state, { payload }) => {
			state.currentTicketPermissions = state.currentTicketPermissions.map((permission) =>
				permission.id === payload.ticketShareId
					? { ...permission, permission: payload.permission }
					: permission
			);
		});
	},
});

export const { setIsCreateTicketShareOpen, resetTicketShareStore } = ticketShareSlice.actions;

export default ticketShareSlice.reducer;
